import { memo, useCallback } from "react";
import { useShallow } from "zustand/shallow";
import { useMapRouteStore } from "@/stores/mapRouteStore";

// Вынесены за пределы компонента
const formatDurationMinutes = (seconds: number) => {
  return Math.ceil(seconds / 60);
};

const formatDistanceValue = (meters: number) => {
  if (meters >= 1000) {
    return { value: (meters / 1000).toFixed(1), unit: "км" };
  }
  return { value: Math.round(meters), unit: "м" };
};

const RouteSummary = memo(function RouteSummary() {
  const { direction, showFullRoute } = useMapRouteStore(
    useShallow((s) => ({
      direction: s.direction,
      showFullRoute: s.showFullRoute,
    })),
  );

  const handleShowFullRoute = useCallback(() => {
    showFullRoute();
  }, [showFullRoute]);

  if (!direction) return null;

  const { totalDuration, totalDistance } = direction.segmentationRoute;
  const distance = formatDistanceValue(totalDistance);

  return (
    <div
      className="shrink-0 flex items-center px-4 py-[14px]"
      style={{
        background: "linear-gradient(135deg, #1a5fb4 0%, #0d3a7a 100%)",
      }}
    >
      {/* Time */}
      <div className="flex items-baseline gap-1">
        <span className="text-[22px] font-bold text-white">
          {formatDurationMinutes(totalDuration)}
        </span>
        <span className="text-[13px] font-medium text-white/70">мин</span>
      </div>

      {/* Divider */}
      <div className="w-px h-6 bg-white/20 mx-4" />

      {/* Distance */}
      <div className="flex items-baseline gap-1">
        <span className="text-[22px] font-bold text-white">
          {distance.value}
        </span>
        <span className="text-[13px] font-medium text-white/70">
          {distance.unit}
        </span>
      </div>

      {/* Expand button */}
      <button
        onClick={handleShowFullRoute}
        className="ml-auto w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
        title="Показать весь маршрут"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="w-4 h-4 text-white"
        >
          <path d="M7 17L17 7M17 7H7M17 7V17" />
        </svg>
      </button>
    </div>
  );
});

export default RouteSummary;
